import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";

export default {
  props: {
    parentId: String,
  },
  data() {
    return {
      sortName: "ASC",
      spaces: [],
      doneSearching: false,
    };
  },
  created() {
    EventBus.$on("setSpacesSort", (data) =>
      this.parentId === data.id ? this.setSortName(data.value) : null
    );

    EventBus.$on(`${this.$options.name}-update-spaces`, () =>
      this.updateSpaces()
    );
  },
  beforeMount() {
    this.updateSpaces();
  },
  methods: {
    updateSpaces() {
      this.doneSearching = false;

      this.$axios
        .get(baseUrl + "/roots", {
          responseType: "json",
        })
        .then((r) => {
          this.spaces = r.data;

          this.sortSpaces(this.sortName);

          this.doneSearching = true;
        });
    },
    setSortName(sortName) {
      this.sortName = sortName;
    },
    sortValues(a, b) {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    },
    sortSpaces(sortName) {
      if (this.spaces.length > 0) {
        let spaces = this.spaces;

        switch (sortName) {
          case "ASC":
            this.spaces = spaces.sort((a, b) =>
              this.sortValues(a.name, b.name)
            );

            break;

          case "DATE":
            this.spaces = spaces.sort((a, b) =>
              this.sortValues(new Date(b.updated_at), new Date(a.updated_at))
            );

            break;

          default:
            return this.spaces;
        }
      }
    },
  },
  watch: {
    sortName(newSortName) {
      this.sortSpaces(newSortName);
    },
  },
};
